export const LIST_NEARBY_STATIONS = 'LIST_NEARBY_STATIONS'
export const SET_USER_INFO = 'SET_USER_INFO'
export const LIST_USERS_SESSIONS = 'LIST_USERS_SESSIONS'

export default {
    LIST_NEARBY_STATIONS,
    SET_USER_INFO,
    LIST_USERS_SESSIONS
}
